import { lockScroll, unlockScroll } from '@theme/utilities';

// Altersabfrage 18+ — Markup, Verhalten und Begründung in snippets/cd-age-gate.liquid.

const STORAGE_KEY = 'cd_age_ok';

function isConfirmed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function remember() {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Ohne Speicher (privates Fenster, gesperrte Website-Daten) fragt die
    // nächste Seite eben wieder. Der Shop bleibt benutzbar.
  }
}

function isExternalReferrer() {
  try {
    return document.referrer !== '' && new URL(document.referrer).origin !== window.location.origin;
  } catch {
    return false;
  }
}

class CdAgeGate extends HTMLElement {
  connectedCallback() {
    if (isConfirmed()) return;

    const dialog = this.querySelector('dialog');
    if (!dialog) return;

    let accepted = false;

    // Fallback zu `closedby="none"`: Schliesst der Browser trotzdem (ESC,
    // Zurück-Geste), sofort wieder öffnen. Entsperrt wird nur nach „Ja".
    dialog.addEventListener('cancel', (event) => event.preventDefault());
    dialog.addEventListener('close', () => {
      if (accepted) {
        unlockScroll(dialog);
      } else {
        dialog.showModal();
      }
    });

    this.querySelector('[data-age-yes]')?.addEventListener('click', () => {
      accepted = true;
      remember();
      dialog.close();
    });

    this.querySelector('[data-age-no]')?.addEventListener('click', (event) => {
      // Zurück dorthin, woher der Besuch kam (Entscheidung 2026-10-09; später
      // ersetzt eine eigene Landingpage das). Nur bei fremder Herkunft: Eine
      // Shop-Seite davor zeigte die Abfrage nur wieder.
      if (window.history.length > 1 && isExternalReferrer()) {
        window.history.back();
        return;
      }

      // Kein Weg zurück (direkt aufgerufen, Lesezeichen): Abschiedssatz wie im Entwurf.
      const text = this.querySelector('[data-bye]');
      if (text) text.textContent = text.dataset.bye;
      event.currentTarget.hidden = true;
      this.querySelector('[data-age-yes]')?.focus();
    });

    lockScroll(dialog);
    dialog.showModal();
  }
}

if (!customElements.get('cd-age-gate')) customElements.define('cd-age-gate', CdAgeGate);
